import { IAdditionalDocumentsRequest } from 'src/shared/types/Documents';
import { ICountryImmigrationData } from 'src/shared/types/Immigration';
import { IImmigrationDocDetailCountryModel, IImmigrationDocDetailModel } from 'src/shared/types/ImmigrationDocument';
import { createApiFetcher, createApiPoster } from 'src/utils/ApiUtils';

export interface IProfileImmigrationDocDetailsParams {
  beneId?: string;
  dependentId?: string;
  includeDocument?: false;
}

const fetchData = createApiFetcher('immigrationdocuments/');
const postData = createApiPoster('immigrationdocuments/');

export const getProfileImmigrationDocDetails = (
  params: IProfileImmigrationDocDetailsParams
): Promise<ICountryImmigrationData[]> => fetchData<ICountryImmigrationData[]>('profile-details', { ...params });

export const getImmigrationDocDetails = async (
  beneId: number | undefined,
  dependentId: number | undefined,
  includeDocuments: boolean
): Promise<IImmigrationDocDetailModel[]> =>
  fetchData<IImmigrationDocDetailModel[]>(
    `details?beneId=${beneId ?? ''}&dependentId=${dependentId ?? ''}&includeDocuments=${includeDocuments}`
  );

export const getImmigrationDocDetailsById = async (
  immigrationDocId: number | undefined
): Promise<IImmigrationDocDetailCountryModel> =>
  fetchData<IImmigrationDocDetailCountryModel>(`details/${immigrationDocId ?? ''}`);

export const linkRemoteDocumentsToCase = async (document: IAdditionalDocumentsRequest): Promise<unknown> => {
  return await postData(`link-remote-documents-to-case`, document);
};
